module.exports = __webpack_public_path__ + "cd3f9512bdb9583725ed2574bebe36bf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-29.png
// module id = 1765
// module chunks = 0